import React, { Component, Fragment } from "react";
import { get, find } from "lodash";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Menu, MenuItem, Avatar, Typography, Button } from "@mui/material";
import { withStyles } from "@mui/styles";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import Resource from "common/components/Resource";
import i18n from "i18next";
import { PREFERRED_LANGS, AppValues } from "common/constants";
import { localStorage, setItem, getItem, setLangCode } from "common/storage";

const resourceName = ({ resourceType }) =>
  resourceType === "building" ? "buildings" : "businesses";

const url = ({ resourceType, resourceId }) =>
  resourceType === "building"
    ? `/${resourceType}/${resourceId}/notifications`
    : `/${resourceType}/${resourceId}/offers`;

const styles = (theme) => ({
  menuItemText: {
    marginLeft: theme.spacing(1),
  },
  avatar: {
    marginRight: theme.spacing(1),
  },
  link: {
    textDecoration: "none",
    color: "inherit",
  },
});

const AvatarWithFallback = ({ resource, className }) =>
  resource.logo_url ? (
    <Avatar
      alt={`${resource.name} Logo`}
      src={resource.logo_url}
      className={className}
    />
  ) : (
    <Avatar className={className}>{get(resource, "name[0]", "")}</Avatar>
  );

AvatarWithFallback.propTypes = {
  resource: PropTypes.shape({
    name: PropTypes.string.isRequired,
    logo_url: PropTypes.string,
  }).isRequired,
  className: PropTypes.string.isRequired,
};

class AccountSwitcher extends Component {
  static propTypes = {
    urlResource: PropTypes.shape({
      id: PropTypes.number.isRequired,
      singular: PropTypes.string.isRequired,
    }).isRequired,
    permissions: PropTypes.arrayOf(
      PropTypes.shape({
        resourceId: PropTypes.string.isRequired,
        resourceType: PropTypes.string.isRequired,
      }),
    ).isRequired,
    classes: PropTypes.object.isRequired,
  };

  state = {
    anchorEl: null,
  };

  handleClick = (e) => {
    this.setState({ anchorEl: e.currentTarget });
  };

  storeMultilingual = (value, is_hilo) => {
    const multilingual = getItem(localStorage, AppValues.multilingual);
    if (multilingual !== value) {
      setItem(localStorage, AppValues.multilingual, value);
    }
    setItem(localStorage, AppValues.hilo, is_hilo ? true : false);
  };

  handleClose = (permission) => {
    if (
      permission?.resourceId != null &&
      i18n.resolvedLanguage !== PREFERRED_LANGS[0].value
    ) {
      setLangCode(true, PREFERRED_LANGS[0].value);
      i18n.changeLanguage(PREFERRED_LANGS[0].value);
    }
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;
    const { permissions, classes, urlResource } = this.props;
    const currentPermission =
      find(permissions, {
        resourceId:
          String(urlResource.id) || window.location.pathname.split("/").pop(),
        resourceType: urlResource.singular,
      }) || permissions[0];

    return (
      <Fragment>
        {currentPermission ? (
          <Button
            style={{ marginLeft: ".65em" }}
            color="inherit"
            onClick={this.handleClick}
          >
            <Resource
              name={resourceName(currentPermission)}
              resourceId={currentPermission.resourceId}
              render={(res) => {
                this.storeMultilingual(!!res?.multilingual, res?.is_hilo);

                return (
                  <Fragment>
                    <AvatarWithFallback
                      resource={res}
                      className={classes.avatar}
                    />

                    <Typography
                      component="span"
                      variant="inherit"
                      style={{
                        fontWeight: "bold",
                        fontSize: ".9em",
                        display: "inline",
                      }}
                    >
                      {res.name}
                    </Typography>
                    <ArrowDropDown />
                  </Fragment>
                );
              }}
            />
          </Button>
        ) : null}
        <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={this.handleClose}>
          {permissions.map((permission) => {
            const resourceUrl = url(permission);
            return (
              <Resource
                key={resourceUrl}
                name={resourceName(permission)}
                resourceId={permission.resourceId}
                render={(resource) => (
                  <Link to={resourceUrl} className={classes.link}>
                    <MenuItem onClick={() => this.handleClose(permission)}>
                      <AvatarWithFallback
                        resource={resource}
                        className={classes.avatar}
                      />
                      <Typography className={classes.menuItemText}>
                        {resource.name}
                      </Typography>
                    </MenuItem>
                  </Link>
                )}
              />
            );
          })}
        </Menu>
      </Fragment>
    );
  }
}

export default withStyles(styles)(AccountSwitcher);
